export const USER_TYPE_RESIDENT = 'RESIDENT';
export const USER_TYPE_EMPLOYEE = 'EMPLOYEE';
export const USER_TYPE_REGENT = 'REGENT';